export const ISCOLLECT = 'ISCOLLECT'


// WEBPACK FOOTER //
// ./src/stroe/mutation-types.js